/* Promo Grid Ad — drops one non-clickable promo tile at a random slot in the
   collection/search product grid. Re-injects after Dawn re-renders the grid on
   filter/sort (it replaces #ProductGridContainer). Config from the mounted
   <script id="promo-grid-ad-config">. Doc: docs/promo-auto-add.md */

(() => {
  if (window.__promoGridAdInit) return;
  window.__promoGridAdInit = true;

  const cfgEl = document.getElementById('promo-grid-ad-config');
  if (!cfgEl) return;
  let cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  if (!cfg.enabled || !cfg.imageUrl) return;

  // Date window (local time; end date inclusive through end of day)
  const parse = (s) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((s || '').trim());
    return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null;
  };
  const now = new Date();
  const start = parse(cfg.startDate);
  if (start && now < start) return;
  const end = parse(cfg.endDate);
  if (end) {
    end.setDate(end.getDate() + 1);
    if (now >= end) return;
  }

  const AD_CLASS = 'promo-grid-ad-card';

  function buildTile() {
    const li = document.createElement('li');
    li.className = 'grid__item ' + AD_CLASS;
    li.setAttribute('aria-hidden', 'true'); // decorative ad, not a product
    const inner = document.createElement('div');
    inner.className = AD_CLASS + '__inner';
    const img = document.createElement('img');
    img.src = cfg.imageUrl.startsWith('//') ? 'https:' + cfg.imageUrl : cfg.imageUrl;
    img.alt = '';
    img.loading = 'lazy';
    img.width = 1080;
    img.height = 1080;
    inner.appendChild(img);
    li.appendChild(inner);
    return li;
  }

  function inject(grid) {
    if (!grid || grid.querySelector('.' + AD_CLASS)) return;
    const items = Array.from(grid.children).filter((c) => c.classList.contains('grid__item'));
    if (items.length === 0) return;
    // Random slot, but kept near the top so the ad is actually seen as browsing
    // starts (uniform-random across a 170-product grid would usually bury it).
    // Never slot 0 (keep the lead product prominent).
    const lo = Math.min(2, items.length);
    const hi = Math.min(items.length, cfg.maxSlot || 9);
    const idx = hi <= lo ? lo : lo + Math.floor(Math.random() * (hi - lo + 1));
    const tile = buildTile();
    if (idx >= items.length) grid.appendChild(tile);
    else grid.insertBefore(tile, items[idx]);
  }

  const findGrid = () => document.getElementById('product-grid');

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      inject(findGrid());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // Dawn swaps #ProductGridContainer innerHTML on facet filter/sort → re-inject.
  const container = document.getElementById('ProductGridContainer');
  if (container) {
    const obs = new MutationObserver(() => {
      const grid = findGrid();
      if (grid && !grid.querySelector('.' + AD_CLASS)) schedule();
    });
    obs.observe(container, { childList: true, subtree: true });
  }
})();
